<template>
  <v-layout wrap>
    <v-flex>
      <v-layout wrap v-if="tickets">
        <v-flex
          xs12
          sm12
          v-for="ticket in tickets"
          v-bind:key="ticket._id"
          class="list-section pa-2 mb-0 mb-3"
        >
          <div>
            <h3 class="headline mb-0">{{ticket.subject}}</h3>            
            <div v-html="trimTicketText(ticket.description)"></div>
            <br>
            <div>
              <b>
                Ticket No:
                <span>{{ticket.ticket_no}}</span>
              </b>
            </div>
            <div>
              <b>
                Ticket Status:
                <span v-if="ticket.status == 'Open'" style="color: green">{{ticket.status}}</span>
                <span v-else-if="ticket.status == 'Closed'" style="color: red">{{ticket.status}}</span>
              </b>
            </div>
            <div>
              <b>Posted On:</b>
              {{ticket.createdAt | moment("DD MMMM YYYY") }}
            </div>
          </div>

          <div>
            <v-btn icon :to="`/ticket/details/${ticket._id}`">
              <v-icon color="green">visibility</v-icon>
            </v-btn>
            <!-- <v-btn v-if="ticket.status == 'Open'" icon :to="`/ticket/create?id=${ticket._id}`">
              <v-icon color="orange">edit</v-icon>
            </v-btn> -->
            <!-- <v-btn icon @click="deleteModal(ticket)">
              <v-icon color="red">delete</v-icon>
            </v-btn> -->
          </div>
        </v-flex>

              <!-- delete dialog -->
      <v-dialog v-model="deleteDialog" max-width="600px">
        <v-toolbar class="red" dark dense>
          <v-toolbar-title>Delete Ticket</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="deleteDialog=false">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
              <p>Are you sure you want to delete this ticket?</p>
              <p>{{ticketItem.title}}</p>
            </v-flex>
            <v-flex xs12>
              <v-btn color="red" class="right" small dark @click="deleteTicket">
                <v-icon left>delete</v-icon>Yes
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
      <!-- end of delete  -->

      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import { trimTicketText } from "@/common/methods.js";
export default {
  name: "TicketsList",
  props: {
    tickets: {
      type: Array,
      default: []
    },
  },
  computed: {
    ...mapGetters(["host"]),
    ...mapGetters(["user"])
  },
  data() {
    return {
      loader: false,
      ticketItem: {},
      deleteDialog: false,
      deleteItem: {},
    };
  },
  methods: {
    trimTicketText,
    deleteModal(data) {
      this.ticketItem = Object.assign({}, data);
      this.deleteDialog = true;
    },
    deleteTicket(id) {
      const ticket = this.ticketItem;
      const ticketUser = this.user;
      const self = this;
      self.loader = true;
      const res = this.$store
        .dispatch("remove", "/ticket/delete/"+ ticket._id)
        .then(res => {
          if(res.state) {
            location.reload();
          } 
        })
        .finally(() => {});
    },
  }
};
</script>
<style>
  .btntext {
    text-transform: none;
  }
  .jobStatus {
    color: #008000;
  }
</style>